"use client";
import React from "react";
import { Menu as MenuType } from "../../../payload-types";

import MenuMobile from "./menu-mobile";
import MenuDesktop from "./menu-desktop";
import { useMediaQuery } from "usehooks-ts";

export type MenuProps = {
  menu: MenuType | undefined | null;
};

export default function Menu({ menu }: MenuProps) {
  const isMobile = useMediaQuery("(max-width: 767px)", { initializeWithValue: false });
  return (
    <React.Fragment>
      {isMobile ? <MenuMobile menu={menu} /> : <MenuDesktop menu={menu} />}
    </React.Fragment>
  );
}
